import { Component, inject, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CreateMaintenanceRecordService } from '../services/create-maintenance-record.service';
import { ClaimDto } from 'src/app/auto-generated-server-dtos/claim/claim-dto';
import { NgModel } from '@angular/forms';
import { MaintenanceTermDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/maintenance-record/maintenance-term-dto';

@Component({
  selector: 'app-add-maintenance-modal',
  templateUrl: './add-maintenance-modal.component.html',
  styleUrl: './add-maintenance-modal.component.scss'
})
export class AddMaintenanceModalComponent {
  @ViewChild("scheduledKmsElement", { static: false }) scheduledKmsElement!: NgModel;
  @ViewChild("performedKmsElement", { static: false }) performedKmsElement!: NgModel;
  @ViewChild("performedDateElement", { static: false }) performedDateElement!: NgModel;
  @ViewChild("maintenanceTermIdElement", { static: false }) maintenanceTermIdElement!: NgModel;
  @Input() claimDto!: ClaimDto;
  @Input() terms: MaintenanceTermDto[] = [];

  private today = new Date();
  maxDate: NgbDateStruct = {
    year: this.today.getFullYear(),
    month: this.today.getMonth() + 1,
    day: this.today.getDate()
  };

  isSubmitting = false;
  hasError = false;
  
  activeModal = inject(NgbActiveModal);
  createMaintenanceRecordService = inject(CreateMaintenanceRecordService);

  addMaintenanceRecord() {
    if (!this.validateForm()) {
      return;
    }

    this.isSubmitting = true;
    this.hasError = false;

    const maintenance = {
      scheduledKms: this.scheduledKmsElement.value,
      performedKms: this.performedKmsElement.value,
      performedDate: this.formatDate(this.performedDateElement.value),
      maintenanceTermId: this.maintenanceTermIdElement.value,
      claimId: this.claimDto.claimId,
    };

    this.createMaintenanceRecordService.createMaintenance(maintenance).subscribe({
      next: () => {
        this.activeModal.close(true);
      },
      error: () => {
        this.isSubmitting = false;
        this.hasError = true;
      }
    });
  }

  formatDate($event: NgbDate) {
    const month = JSON.stringify($event.month);
    const day = JSON.stringify($event.day);
    
    return `${$event.year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  private validateForm() {
    const controls = [
      this.scheduledKmsElement,
      this.performedKmsElement,
      this.maintenanceTermIdElement,
      this.performedDateElement
    ];

    controls.forEach(formInput => formInput.control.markAsTouched());
    return !controls.some(c => c.control.errors);
  }
}
